import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {useRefraPlanningTracking} from '../tracking'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditMaterialInstallation = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()
  const tracking = useRefraPlanningTracking()

  return useRefraMutation({
    mutationFn: mutations.editMaterialInstallation,
    mutationKey: ['editMaterialInstallation'],
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditMaterialInstallation')
        .extras({errorDetails})
        .error('Error occurred while adding a new material to shutdown')

      spawnErrorToast(t('error.editMaterialInstallation'))
    },
    onSuccess: async (_, {plantUpmId, kilnUpmId, shutdownId, installationId, material}) => {
      tracking.materialInstallation.edit(installationId, material)

      await queryClient.invalidateQueries({
        queryKey: [
          'kilnReplacement',
          {
            plantUpmId,
            kilnUpmId,
            shutdownId
          }
        ]
      })
      await queryClient.invalidateQueries({
        queryKey: ['materialInstallationDetails']
      })
      spawnSuccessToast(t('success.editMaterialInstallation'))
    }
  })
}
